export const productsRoot = "products";
export const getById = "products";
export const getAll = "products/all";
export const getByBrand = "products/getByBrand";
export const postSearch = "products/search";
export const getCategories = "products/categories/all";
